import createIcon from '../../createIcon';

/**
 * @component @name MovieFilter
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggNEwyMCA3SDE3TDE1IDRIMTNMMTUgN0gxMkwxMCA0SDhMMTAgN0g3TDUgNEg0QzIuOSA0IDIuMDEgNC45IDIuMDEgNkwyIDE4QzIgMTkuMSAyLjkgMjAgNCAyMEgyMEMyMS4xIDIwIDIyIDE5LjEgMjIgMThWNEgxOFpNMTEuMjUgMTUuMjVMMTAgMThMOC43NSAxNS4yNUw2IDE0TDguNzUgMTIuNzVMMTAgMTBMMTEuMjUgMTIuNzVMMTQgMTRMMTEuMjUgMTUuMjVaTTE2Ljk0IDExLjk0TDE2IDE0TDE1LjA2IDExLjk0TDEzIDExTDE1LjA2IDEwLjA2TDE2IDhMMTYuOTQgMTAuMDZMMTkgMTFMMTYuOTQgMTEuOTRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MovieFilter = createIcon('MovieFilter', [
  [
    'path',
    {
      d: 'M18 4L20 7H17L15 4H13L15 7H12L10 4H8L10 7H7L5 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V4H18ZM11.25 15.25L10 18L8.75 15.25L6 14L8.75 12.75L10 10L11.25 12.75L14 14L11.25 15.25ZM16.94 11.94L16 14L15.06 11.94L13 11L15.06 10.06L16 8L16.94 10.06L19 11L16.94 11.94Z',
      key: '1jr6i5',
    },
  ],
]);

export default MovieFilter;
